import React from 'react';
import { Routes, Route } from 'react-router-dom';

import FlavourFanatic from './flavour-fanatic';

import './styles.css';

export default function BenJerrys() {
  return (
    <Routes>
      <Route path="/flavour-fanatic" element={<FlavourFanatic />} />
    </Routes>
  );
}
